import * as React from "react";

const Welcome: React.FC<{}> = () => {
    const content: JSX.Element = (
        <div className="Welcome">
            <img src="/IB.svg" />
            <div className="grid">
                <div className="ib1" />
                <div className="ib2" />
                <div className="ib3" />
                <div className="ib4" />
                <div className="ib5" />
                <div className="ib6" />
            </div>
        </div>
    );
    return content;
};

export default Welcome;
